import { configureStore } from '@reduxjs/toolkit'
import userReducer from './user/reducer'
import menuReducer from './menu/reducer'
import learnReducer from './learn/reducer'
import liveReducer from './live/reducer'
import test from './test/reducer'
import registerReducer from './register/reducer'
import coachingCenter from './coachingCenter/reducer'
import courseReducer from './course/reducer'
import branchReducer from './branch/reducer'
import batchReducer from './batch/reducer'
import materialReducer from './materialAccess/reducer'
import userDetailReducer from './userDetail/reducer'
import addMaterialReducer from './addMaterial/reducer'
import sessionReducer from './session/reducer'
import lessonReducer from './lesson/reducer'
import learnSessionReducer from './learnSession/reducers'
import leaveReducer from './manageLeave/reducer'
import qrReducer from './qrCode/reducer'
import createTestReducer from './createTest/reducer'
import dashboardRedeucer from './Dashboard/reducer'
import studentQRcodeReducer from './studentQrCode/reducer'

const reducer = {
  user: userReducer,
  menu: menuReducer,
  learn: learnReducer,
  live: liveReducer,
  test: test,
  register: registerReducer,
  coachingCenter: coachingCenter,
  course: courseReducer,
  branch: branchReducer,
  batch: batchReducer,
  material: materialReducer,
  userDetail: userDetailReducer,
  addMaterial: addMaterialReducer,
  session: sessionReducer,
  lesson: lessonReducer,
  learnSession: learnSessionReducer,
  leave: leaveReducer,
  qrcode: qrReducer,
  createTest: createTestReducer,
  dashboard: dashboardRedeucer,
  studentsQr: studentQRcodeReducer
}

const initialState = {}

export const store = configureStore({
  reducer: reducer,
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
